module.exports = __webpack_public_path__ + "static/media/mid1.694ba613.jpg";